import { Type } from "class-transformer";
import { CalendarOutlineEvent } from "./CalendarOutlineEvent";
import { Project } from "./Project";

export class CreateProjectDto {
    @Type(() => Project)
    project: Project;
    @Type(() => CalendarOutlineEvent)
    events: CalendarOutlineEvent[];
    eventIdsToDelete: number[];
    propertiesToUpdate: string[];
}
